export class ArrayHelper {
  // Helper for string arrays in botUser.variables
  static getSet(array?: string, toLower = false): Set<string> {
    let valuesString = array || "";
    if (toLower) {
      valuesString = valuesString.toLowerCase();
    }
    let set = new Set(
      valuesString
        .split(",")
        .map((v) => {
          return v.trim();
        })
        .filter((v) => v.length > 0)
    );
    return set;
  }
  static getArray(array?: string): string[] {
    let valuesString = array || "";
    return valuesString
      .split(",")
      .map((v) => {
        return v.trim();
      })
      .filter((v) => v.length > 0);
  }
  private static stringify(set: Set<string>) {
    let arrayString = "";
    const iterator = set.values();
    for (const item of iterator) {
      arrayString += item + ",";
    }
    arrayString = arrayString.slice(0, -1);
    return arrayString;
  }
  static clear(_: string): string {
    return "";
  }

  static add(array: string, variables: string): string {
    const arraySet = ArrayHelper.getSet(array);

    const valuesToAdd = variables.split(",").map((v) => v.trim());

    valuesToAdd.forEach((v) => arraySet.add(v));
    return ArrayHelper.stringify(arraySet);
  }
  static remove(array: string, variables: string): string {
    const arraySet = ArrayHelper.getSet(array);
    const valuesToAdd = variables.split(",").map((v) => v.trim());
    valuesToAdd.forEach((v) => arraySet.delete(v));
    return ArrayHelper.stringify(arraySet);
  }
  static has(array: string, variables: string): boolean {
    const arraySet = ArrayHelper.getSet(array, true);
    const valuesToAdd = variables
      .toLowerCase()
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v.length > 0);

    if (valuesToAdd.length === 0) {
      return false;
    }
    //Check to see that it is lower case on compare
    var has = true;
    valuesToAdd.forEach((v) => {
      if (!arraySet.has(v)) {
        has = false;
      }
    });
    return has;
  }

  static getCount(array: string): number {
    const arraySet = ArrayHelper.getSet(array, false);
    return arraySet?.size || 0;
  }

  static unique<T>(arr: T[], keyProps?: string[]) {
    if (!keyProps) {
      return [...new Set(arr)];
    }
    const kvArray: any = arr.map((entry: T) => {
      const key = keyProps.map((k) => (entry as any)[k]).join("|");
      return [key, entry];
    });
    const map = new Map<string, T>(kvArray);
    return Array.from(map.values());
  }

  static urlBase64ToUint8Array(base64String: string) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(base64);

    const output = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
    return output;
  }
}
